export default __webpack_public_path__ + "static/media/resource1.23ad6246.jpg";